import { useToast } from "@commonlibs";
import { PropsWithChildren, useEffect } from "react";
import useTranslate from "ui/locale/hooks/useTranslate";
import UIErrorEvent from "ui/error/UIErrorEvent";

const ErrorHandler = ({ children }: PropsWithChildren): JSX.Element => {
    const translateError = useTranslate("error");
    const { showToast } = useToast();

    useEffect(() => {
        const handleUiError = (event: UIErrorEvent) => {
            // This timeout ensures that the toast is displayed after the container is mounted
            setTimeout(() => {
                showToast(translateError([event.error.message as never, "somethingWentWrong"]), { type: event.error.severity });
            }, 0);
        };

        UIErrorEvent.addListener(handleUiError);

        return () => {
            UIErrorEvent.removeListener(handleUiError);
        };
    }, []);

    return <>{children}</>;
};

export default ErrorHandler;
